import { StarHalfIc, StarIc, StarOutlineIc } from '@dsch/dd-icons';

type StarType = 'FULL' | 'HALF' | 'EMPTY';

export interface StarProps {
  starType: StarType;
  fillColor?: string;
  emptyColor?: string;
  width?: string;
  height?: string;
}

function Star({
  starType,
  fillColor = '#FF9700',
  emptyColor = '#D9D9D9',
  width = '24',
  height = '24',
}: StarProps) {
  switch (starType) {
    case 'FULL':
      return <StarIc color={fillColor} width={width} height={height} />;
    case 'HALF':
      return <StarHalfIc color={fillColor} width={width} height={height} />;
    case 'EMPTY':
      return <StarOutlineIc color={emptyColor} width={width} height={height} />;
    default:
      return <StarOutlineIc color={emptyColor} width={width} height={height} />;
  }
}

export { Star };
